/**
 * 车辆跟踪组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
	<div class='tabBox' style="background-color: white;" id="carRail" v-loading="loadCarRail" element-loading-text="加载中">
		<div style="float:left;width:calc(100% - 220px); padding: 8px 13px;height:100%;">
				<div class="row">
					<div class="col-sm-6" v-bind:style="{
							height: mapHeight + 'px',
							padding: '7px ',
						}">
						<follow-map ref='map0' showNumber='a' @moveToQueue="moveToQueue" :vehicleInfo="vehicles[0]" :id="0" @refreshPosition="refreshPosition"></follow-map>
					</div>
					<div class="col-sm-6" v-bind:style="{
							height: this.mapHeight + 'px',
							padding: '7px'
						}">
						<follow-map ref='map1' showNumber='b' @moveToQueue="moveToQueue" :vehicleInfo="vehicles[1]" :id="1" @refreshPosition="refreshPosition"></follow-map>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6" v-bind:style="{
							height: this.mapHeight + 'px',
							padding: '7px '
						}">
						<follow-map ref='map2' showNumber='c' @moveToQueue="moveToQueue" :vehicleInfo="vehicles[2]" :id="2" @refreshPosition="refreshPosition"></follow-map>
					</div>
					<div class="col-sm-6" v-bind:style="{
							height: this.mapHeight + 'px',
							padding: '7px '
						}">
						<follow-map ref='map3' showNumber='d' @moveToQueue="moveToQueue" :vehicleInfo="vehicles[3]" :id="3" @refreshPosition="refreshPosition" ></follow-map>
					</div>
				</div>
		</div>
		<div v-bind:style="{
					float:'left',
					width:220 + 'px',
					backgroundColor: 'white',
					height:'100%'
					}">
				<follow-queue ref='queue' @removeToMap="removeToMap" @removeAll="removeAll"></follow-queue>
		</div>
		
		<tab-modal ref="modal1" size="small" :scroll='scrollTop' title="提示" v-on:cancel="confirm">
						{{messageStr}}
						<div slot="footer">
		       				 <!--<button class="btn btn-primary">Say Hi</button>-->
		       				 <button @click="confirm" class="btn btn-primary">确定</button>
				 		</div>
		</tab-modal>
		
	
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import FollowQueue from '../common/FollowQueue.vue'
	import FollowMap from '../common/Map/FollowMap.vue'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	export default {
		name: 'PageCarRail',
		components: {
			FollowQueue,
			FollowMap,
			TabModal
		},
		data() {
			return {
				firstOpen:true,
				mapHeight:400,
				messageStr: "",	// 弹出框提示内容
				scrollTop: '0'
			};
		},
		computed:mapState({
			vehicles:state=>state.monitor.vehicles,
			showCarTip:state=>state.monitor.showCarTip,
			railTipCnt:state=>state.monitor.railTipCnt,
			loadCarRail:state=>state.monitor.loadCarRail,
			addCarToTrack:state=>state.monitor.addCarToTrack
		}),
		watch:{
			showCarTip:function(val){
				if(val){
					const self = this;
					this.openModal1(self.railTipCnt)
				}else{
					this.closeModal("modal1")
				}
			},
			addCarToTrack(val){
				if(val){
					this.$refs.queue.getQueue(1);//更新队列 
				} 
			}
		},
		beforeMount(){
			this.$store.dispatch('getTrackMap')
		},
		mounted() {
			var totalHeight = $('.tabBox').height();
			this.mapHeight = (totalHeight + 4) / 2 ;
		},
		beforeDestroy(){
			this.refresh()
		},
		methods:{
			//移除全部后
			removeAll(){//跟踪右侧队列点击清空全部后--同时也要清空地图上的车
				this.vehicles.forEach(function(value,index,arr){
					if(value.lockFlg==0){
						value.valid = false;
						//改为前台同步操作 
						value.checked = false;
						value.vehicleId = '';
						value.id = ''
					}	
				})		
			},
			//一个地图被移到队列后的回调
			moveToQueue(follow_map){
				this.vehicles[follow_map.id].id = ''
				this.vehicles[follow_map.id].vehicleId = ''
				this.vehicles[follow_map.id].checked = false
				this.vehicles[follow_map.id].valid =false;//车辆移出，更新属性
				this.$refs.queue.getQueue(1);//更新队列
			},
			//有个队列中的被移到地图了
			removeToMap(vehicle){
				let vehicle2Add = this.vehicles.find((v)=>v.valid==false);
				if(vehicle2Add == undefined){
					this.openModal1("异常,追踪队列已满")
					return ;
				}
				vehicle2Add.lockFlg = vehicle.lockFlg
				vehicle2Add.vehicleId = vehicle.vehicleId;
				vehicle2Add.ownerName = vehicle.clientName;
				vehicle2Add.plateNumber = vehicle.plateNumber;
				vehicle2Add.id = vehicle.id;
				vehicle2Add.lng =vehicle.lng;
				vehicle2Add.lat = vehicle.lat;
				vehicle2Add.valid = true;
			},
			//位置被刷新了
			refreshPosition(option){
				if(option.locSuccess){
				this.vehicles[option.id].lat=option.point.lat;
				this.vehicles[option.id].lng=option.point.lng;
				this.vehicles[option.id].speed=option.speed;
				this.vehicles[option.id].locSuccess = true;
				}else{
					this.vehicles[option.id].locSuccess = false;
				}
			},
			//获取跟踪数量
			getTrackCount(){
				let rtn =0;
				for(let i = 0;i<this.vehicles.length;i++){
					if(this.vehicles[i].valid) rtn++;
				}
				return rtn;
			},
			//刷新 需要刷新时调用
			refresh(){
				this.vehicles = [
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0}		
				],
			//	this.getTrackData();
				this.$refs.queue.refresh(1);
			},
			
			// 消息弹出框相关 ==============================
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#carRail',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		this.$store.dispatch('hideRailModal')
        		classlist.toggleScroll('open','#carRail',this);
        	},
        	openModal1(message){
        		this.messageStr = message;
        		this.openModal("modal1")
        	},
        	confirm(){
        		this.closeModal("modal1");
        		// 通知父组件刷新数据
				this.$emit("callback", "new-success");
        	}
			
			
			
		}
	};
</script>


// WEBPACK FOOTER //
// PageCarRail.vue?2302375c